import { useQuery } from '@tanstack/react-query';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AutomationVersionTestSuite } from '@/types/automations.ts';
import { AUTOMATION_VERSION_TEST_SUITE_KEY } from '@/utils/queryKeys.ts';
import { get_automation_builder_version_test_suite_url } from '@/utils/urls.ts';

const useRetrieveAutomationVersionTestSuite = (versionId?: string, enabled = true) => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery<AutomationVersionTestSuite, Error>({
    queryKey: AUTOMATION_VERSION_TEST_SUITE_KEY(automationId, versionId),
    queryFn: async () => (
      await apiClient.get(get_automation_builder_version_test_suite_url(automationId, versionId))
    ).data,
    enabled: enabled && !!automationId && !!versionId,
    staleTime: 0,
  });
};

export default useRetrieveAutomationVersionTestSuite;
